<template>
    <v-container class="mb-6">

        <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>

        <v-row class="mt-1">
            <v-col cols="12" sm="5">
                <h4>Nueva categoria</h4>
                <v-card>
                    <v-card-text>
                        <v-form @submit.prevent="registerCat" ref="refAddCat" lazy-validation>
                            <v-text-field
                                label="Nombre de la categoría"
                                dense
                                outlined
                                :rules="[rules.required]"
                                v-model="nameCat"
                                :error="(errors['name']) ? true : false"
                                :error-messages="(errors['name']) ? errors['name'][0] : ''"
                            ></v-text-field>
                            <v-select
                                :items="itemsSizes"
                                label="Tamaño de los banners por categoría"
                                item-text="label"
                                item-value="val"
                                outlined
                                dense
                                :rules="[rules.required]"
                                v-model="sizeBanner"
                            ></v-select>
                            <div class="mb-4" style="width:150px">
                                <h5>Vista previa alto</h5>
                                <v-img
                                    :aspect-ratio="sizeBanner"
                                    class="grey"
                                ></v-img>
                            </div>
                            <div class="text-right">
                                <v-btn color="primary" type="submit" :loading="loading">
                                    Añadir
                                </v-btn>
                            </div>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col cols="12" sm="7">
                <h4>Categorias</h4>
                <v-card>
                    <v-card-text>
                        <draggable
                            :list="listCat"
                            :disabled="!enabled"
                            class="list-group"
                            ghost-class="ghost"
                            :move="checkMove"
                            @start="dragging = true"
                            @end="dragging = false"
                        >
                            <div
                                class="list-group-item"
                                v-for="element in listCat"
                                :key="element.id"
                            >
                                <div class="row align-center">
                                    <div class="col-8">
                                        <v-edit-dialog
                                            :return-value.sync="element.name"
                                            @save="save(element.id, element.name, element.size_banner, element.state, element.children)"
                                            @cancel="cancel"
                                            large
                                            persistent
                                        > {{ element.name }}
                                            <template v-slot:input>
                                                <v-text-field
                                                    v-model="element.name"
                                                    label="Editar"
                                                    single-line
                                                    dense
                                                ></v-text-field>
                                                <v-select
                                                    :items="itemsSizes"
                                                    label="Tamaño de los banners por categoría"
                                                    item-text="label"
                                                    item-value="val"
                                                    single-line
                                                    dense
                                                    v-model="element.size_banner"
                                                ></v-select>
                                                <!-- status -->
                                                <v-switch
                                                    v-model="element.state"
                                                    inset
                                                    :label="`Estado: ${(element.state)?'activo':'inactivo'}`"
                                                ></v-switch>
                                                <!-- end status -->
                                                <!-- subcategorias -->
                                                <v-sheet outlined color="grey lighten-4 pa-3">
                                                    <h5 class="mb-2">Subcategorias</h5>
                                                    <v-row v-for="(child, j) in element.children" :key="j">
                                                        <v-col cols="5">
                                                            <v-text-field
                                                                label="Nombre de la categoría"
                                                                dense
                                                                outlined
                                                                :rules="[rules.required]"
                                                                v-model="child.name"
                                                            ></v-text-field>
                                                        </v-col>
                                                        <v-col cols="5">
                                                            <v-select
                                                                :items="itemsSizes"
                                                                label="Tamaño de los banners por categoría"
                                                                item-text="label"
                                                                item-value="val"
                                                                outlined
                                                                dense
                                                                :rules="[rules.required]"
                                                                v-model="child.size_banner"
                                                            ></v-select>
                                                        </v-col>
                                                        <v-col cols="2">
                                                            <v-btn
                                                                color="error"
                                                                icon
                                                                @click="element.children.splice(j, 1)"
                                                            >
                                                                <v-icon>mdi-delete</v-icon>
                                                            </v-btn>
                                                        </v-col>
                                                    </v-row>
                                                    <div class="text-right">
                                                        <v-btn
                                                            color="primary"
                                                            small
                                                            @click="element.children.push({id: '', name: '', size_banner: ''})"
                                                        >Añadir</v-btn>
                                                    </div>
                                                </v-sheet>
                                                <!-- END subcategorias -->
                                            </template>
                                        </v-edit-dialog>
                                    </div>
                                    <div class="col-4 text-right">
                                        <v-chip
                                            small
                                            color="success"
                                            v-if="element.state"
                                        >Activo</v-chip>
                                        <v-chip
                                            small
                                            color="error"
                                            v-else
                                        >inactivo</v-chip>
                                        <v-btn icon @click="deleteCat(element.id)">
                                            <v-icon>mdi-delete</v-icon>
                                        </v-btn>
                                    </div>
                                </div>
                                <v-divider></v-divider>
                            </div>
                        </draggable>
                    </v-card-text>
                </v-card>
                <div class="text-right mt-5">
                    <v-btn outlined @click="upOrderCat">
                        Actualizar Orden
                    </v-btn>
                </div>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import draggable from 'vuedraggable'

export default {
    components: {
        draggable,
    },
    data() {
        return {
            overlay: false,
            loading: false,
            breadcrumbs: [
                {
                    text: 'Dashboard',
                    disabled: false,
                    href: '/admin/dashboard',
                },
                {
                    text: 'Mis categorías',
                    disabled: true,
                    href: '',
                }
            ],
            // validation
            rules: {
                required: v => !!v || 'El campo es requerido'
            },
            errors: {},
            nameCat: '',
            itemsSizes: [
                {label: '1:1 Cuadrado', val: +((1/1).toFixed(5))},
                {label: '2:3 Vertical', val: +((2/3).toFixed(5))},
                {label: '3:2 Horizontal', val: +((3/2).toFixed(5))}
            ],
            sizeBanner: '',
            headers: [
                { text: 'Nombre', sortable: false, value: 'name' },
                { text: '', sortable: false, value: 'actions', align: 'end' }
            ],
            listCat: [],
            errors: {},
            // drag
            enabled: true,
            list: [
                { name: "John", id: 0 },
                { name: "Joao", id: 1 },
                { name: "Jean", id: 2 }
            ],
            dragging: false
        }
    },
    created() {
        this.getCategories();
    },
    methods: {
        async getCategories() {
            await axios.post('/admin/list-categories', {type: 'all'})
            .then(response => {
                console.log(response);
                this.listCat = response.data
            })
            .catch(error => {
                // console.log(error);
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                }
            })
        },
        async registerCat () {
            if (this.$refs.refAddCat.validate()) {
                this.errors = {}
                this.loading = true
                await axios.post('/admin/categories', { name: this.nameCat, size: this.sizeBanner })
                .then(response => {
                    // console.log(response);
                    if (response.data === 'ok') {
                        this.$alert('', 'Categoría registrada con éxito.', 'success', {confirmButtonText: 'Continuar'})
                        // this.nameCat = ''
                        this.$refs.refAddCat.resetValidation()
                        this.$refs.refAddCat.reset()
                        this.getCategories();
                    }

                    this.loading = false
                })
                .catch(error => {
                    if (error.response.data.errors) {
                        this.errors = error.response.data.errors
                    }
                    if (error.response.status == 404 || error.response.status == 500) {
                        this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                    }
                    this.loading = false
                })
            }
        },
        save (id, up, size, state, children) {
            // console.log(up);
            const formData = new FormData
            formData.append('name', up)
            formData.append('size', size)
            formData.append('state', state?1:0)
            formData.append('children', JSON.stringify(children))
            formData.append('_method', 'PUT')
            axios.post(`/admin/categories/${id}`, formData)
            .then(response => {
                // console.log(response);
                if (response.data === 'ok') {
                    this.$notify.success("Categoría actualizada con éxito.");
                    this.nameCat = ''
                    this.getCategories();
                }
            })
            .catch(error => {
                // console.log(error);
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                }
                this.getCategories();
            })
        },
        cancel () {
            this.$notify.info("Cancelado.");
        },
        async deleteCat (id) {
            if (confirm('Eliminar categoría. ¿Desea continuar?')) {
                await axios.delete(`/admin/categories/${id}`)
                .then(response => {
                    // console.log(response);
                    if (response.data === 'ok') {
                        this.$notify.success("Categoría eliminada con éxito.");
                        this.getCategories();
                    }
                })
                .catch(error => {
                    if (error.response.status == 404 || error.response.status == 500) {
                        this.$alert('Error, es posible que tenga productos registrados con esta categoría.');
                    }
                })
            }
        },
        // order
        checkMove: function(e) {
            window.console.log("Future index: " + e.draggedContext.futureIndex);
        },
        upOrderCat () {
            const formData = new FormData()
            for (let index = 0; index < this.listCat.length; index++) {
                formData.append(`order[]`, this.listCat[index].id)
            }
            axios.post(`/admin/update-order-cat`, formData)
            .then(response => {
                // console.log(response);
                if (response.data === 'ok') {
                    this.$notify.success("El orden de las categorías fue actualizado con éxito.");
                    this.getCategories();
                }
            })
            .catch(error => {
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                }
            })
        }
    },
}
</script>
<style lang="scss">
    .list-group-item {
        cursor: pointer;
    }
</style>
